class exports.Contracts_Add_Handler extends Handler

    init: () ->
        @layoutUrl = 'backend/portal/contracts/load-layout-add-select'
        @layoutSelector = App.sidebar.contentDiv().find('#add')

        @loadLayout()


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        ths = this

        $('#contract_number').mask '99 - 9999 - 99',
            placeholder: ' '
        @parent.makeValidation('Saving Contract')

        $('#contract_number').keypress (event) ->
            if event.which is 13
                event.preventDefault()
            contractPrefix = @value.substr(0, 2).trim()
            if contractPrefix.length >= 2

                $("#sales_zone option").each ->
                    $(this).removeProp("selected")
                    if $(this).text().substr(0, 2).trim() is contractPrefix
                        $(this).prop("selected", "selected")
